export default {"src":"/_next/static/media/FlowMetterWhite.51d9eea1.svg","height":66,"width":77};